
import { supabase } from "@/integrations/supabase/client";
import { CategoryStatistics } from "./types";

export const CategoryService = {
  async getCategories(): Promise<CategoryStatistics[]> {
    try {
      // In a real implementation, this would query a categories table
      // For now, we'll return mock data
      return [
        { id: "1", name: "Productivity", agentCount: 24, popularity: 85 },
        { id: "2", name: "Education", agentCount: 18, popularity: 75 },
        { id: "3", name: "Business", agentCount: 15, popularity: 70 },
        { id: "4", name: "Entertainment", agentCount: 12, popularity: 65 },
      ];
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  },
  
  async updateCategoryCounts(categories: any[]): Promise<any[]> {
    try {
      const { data: agents, error } = await supabase
        .from('agents')
        .select('category');
      
      if (error) throw error;
      
      // Calculate counts for each category
      const categoryCounts: Record<string, number> = {};
      if (agents) {
        agents.forEach((agent: any) => {
          const category = agent.category;
          if (!categoryCounts[category]) {
            categoryCounts[category] = 0;
          }
          categoryCounts[category] += 1;
        });
      }
      
      // Update category objects with real counts
      return categories.map(category => ({
        ...category,
        count: categoryCounts[category.name.toLowerCase()] || 0
      }));
    } catch (error) {
      console.error("Failed to update category counts:", error);
      return categories;
    }
  }
};
